export default {
    methods: {
        handlerFilter() {
            this.sellSeriesYears = []
            this.sellsSeries = []
            this.getData()
        },
        handlerCleanFilter() {
            this.sellSeriesYears = []
            this.sellsSeries = []
            this.provider = {
                key: null,
                label: 'Selecciona una opción',
            }
            this.selectedYears = []
            this.details.forEach((item) => {
                item.value = 0
                item.series[0].data = []
            })
        },
        formatCurrency(value) {
            const formatter = new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'EUR',
                maximumFractionDigits: 0,
            })
            return formatter.format(value)
        },
        changeProvider(e) {
            this.provider = { key: e.key, label: e.label }
        },
        getParams(client, year) {
            const params = {
                page: 1,
                limit: 10000,
                order: {
                    _EntityId: 'desc',
                },
                filters: [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {},
                    },
                ],
            }
            if (year) {
                params.filters[0].Fields['bill_date'] = {
                    type: 'date',
                    from: `${year}-01-01`,
                    to: `${year}-12-31`,
                }
            }
            if (client && client.key) {
                params.filters[0].Fields['provider'] = {
                    type: 'number',
                    value: client.key,
                    lig: '=',
                }
            }
            return params
        },
        async getData() {
            this.isLoading = true

            const params = this.getParams(this.provider, this.selectedYears[0])
            const res = await this.$gestios.items('expenses').list(params)
            if (res.ok) {
                // total spent
                this.details[0].value = Number(res.data.reduce((acc, cvv) => acc + cvv.total, 0)).toFixed(2)
                this.details[0].series = [
                    { ...this.details[0].series[0], data: res.data.flatMap((item) => item.total) },
                ]

                // bills count
                this.details[1].value = res.data.length
                this.details[1].series = [
                    { ...this.details[1].series[0], data: res.data.flatMap((item) => item.subtotal) },
                ]

                // IVA
                this.details[2].value = Number(res.data.reduce((acc, cvv) => acc + cvv.iva, 0)).toFixed(2)
                this.details[2].series = [{ ...this.details[2].series[0], data: res.data.flatMap((item) => item.iva) }]

                this.isLoading = false

                if (this.selectedYears.length > 0) {
                    this.sellSeriesYears = [this.selectedYears[0]]
                    this.getSellSeries(this.sellSeriesYears[0])
                }
            }
        },
        async getDataByYear(year) {
            return new Promise((resolve) => {
                const params = this.getParams(this.provider, year)
                this.$gestios
                    .items('expenses')
                    .list(params)
                    .then((res) => {
                        if (res.ok) {
                            resolve(res.data)
                        } else {
                            resolve([])
                        }
                    })
            })
        },
        async getSellSeries(year) {
            this.isLoadingSells = true
            if (!this.sellsSeries.length || !this.sellsSeries.find((item) => item.name === year)) {
                const dataYear = await this.getDataByYear(year)
                const data = dataYear.reduce((acc, cvv) => {
                    const month = new Date(cvv.bill_date).getMonth()
                    if (!acc[month]) {
                        acc[month] = 0
                    }
                    acc[month] += cvv.subtotal
                    return acc
                }, [])
                this.sellsSeries.push({
                    name: year,
                    data,
                })
            }
            this.sellsSeries.sort((a, b) => a.name - b.name)
            this.isLoadingSells = false
        },
        handlerAddedPeriod(year) {
            this.getSellSeries(year)
        },
        handlerRemovedPeriod(year) {
            this.sellsSeries = this.sellsSeries.filter((item) => item.name !== year)
        },
    },
}
